import { render, staticRenderFns } from "./index3.6.vue?vue&type=template&id=25f17b0d&scoped=true"
import script from "./index3.6.vue?vue&type=script&lang=js"
export * from "./index3.6.vue?vue&type=script&lang=js"
import style0 from "./index3.6.vue?vue&type=style&index=0&id=25f17b0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f17b0d",
  null
  
)

export default component.exports